import { Box } from "@mui/material";
import TermsOfService from "../components/TermsOfService";
import PrivacyPolicy from "../components/PrivacyPolicy";

// Each legal document lives at its own URL (/terms, /privacy) so
// external reviewers (e.g. Google's OAuth brand verification) and
// footer links can point at a specific document directly. The old
// single /legal route hid the privacy policy behind a client-side
// tab, which read as "no privacy policy" to anyone landing on the
// URL; /legal now redirects to /terms for old links.
const LegalDisclaimerScreen = ({ doc }: { doc: "terms" | "privacy" }) => (
  <Box sx={{ mt: 2, mb: 4 }}>
    {doc === "terms" ? <TermsOfService /> : <PrivacyPolicy />}
  </Box>
);

export default LegalDisclaimerScreen;
